// app/features/news/services_and_hooks/public/newsEditionsPublicService.ts
import { apiGet } from '@/app/shared/utils/api-helpers';

import { DetailedNewsEdition, PersonalizedContent, PublicNewsEdition, PublicStory } from '../../news.interface';

export const newsEditionsPublicService = {
  /**
   * Get all published newsletter editions
   */
  getPublishedEditions: async (): Promise<PublicNewsEdition[]> => {
    const response = await apiGet<{data: PublicNewsEdition[]}>('/api/news/editions');
    if (!response.data?.data) {
      throw new Error('Failed to fetch published editions');
    }
    return response.data.data;
  },

  /**
   * Get specific edition details
   */
  getEditionDetails: async (editionDate: string): Promise<DetailedNewsEdition> => {
    const response = await apiGet<{data: DetailedNewsEdition}>(`/api/news/editions/${editionDate}`);
    if (!response.data?.data) {
      throw new Error('Failed to fetch edition details');
    }
    return response.data.data;
  },

  /**
   * Get personalized version of edition (authenticated users)
   */
  getPersonalizedEdition: async (editionDate: string): Promise<PersonalizedContent> => {
    const response = await apiGet<{data: PersonalizedContent}>(`/api/news/editions/${editionDate}/personalized`);
    if (!response.data?.data) {
      throw new Error('Failed to fetch personalized edition');
    }
    return response.data.data;
  },

  /**
   * Get individual story details
   */
  getStoryDetails: async (storySlug: string): Promise<PublicStory> => {
    const response = await apiGet<{data: PublicStory}>(`/api/news/stories/${storySlug}`);
    if (!response.data?.data) {
      throw new Error('Failed to fetch story details');
    }
    return response.data.data;
  },
}; 